import Card from '../../../Card/components/Card';
import React from 'react';
import { Col, Container, Row } from 'styled-bootstrap-grid';
import Picture, { PictureWrapper } from '../../../Picture/components/Picture';
import styled from 'styled-components';
import Heading from "../../../Typography/components/Heading";

const StyledContainer = styled(Container)`
  border-top: 1px solid #e5e5e5;
  padding-top: 8rem;
  padding-bottom: 8rem;
`;
const Logo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;

  img {
    display: block;
    width: 80%;
    height: auto;
    margin: auto;
  }
  ${PictureWrapper} {
    display:flex;
    align-items: center;
  }
`;

const Clients = (props) => {
  const Clients = props.data.map((client, index) => {
    return <Col col={4} md={3} lg={2} key={index}>
      <Card height="5rem" margin="0 0 1rem">
        <Logo>
          <Picture alt={client.id} defaultSource={require(`../../assets/clients/${client.logo}`)} />
        </Logo>
      </Card>
    </Col>;
  });

  return <StyledContainer>
    <Row>
      <Col col={12}>
        <Heading level={3}>Our clients include:</Heading>
      </Col>
    </Row>
    <Row>
      {Clients}
    </Row>
  </StyledContainer>;
};

export default Clients;
